// Cut-line editing state for the vineyard split tool. State shape:
//   { lines: [ [ [lat,lng], ... ], ... ],   finished cut lines
//     open:  [ [lat,lng], ... ] }           the line being drawn
// Pure reducers so the interaction contract is testable: undo pops points
// first, then re-opens the last finished line (nothing is ever lost to a
// single keypress).

export function cutAddPoint(s, pt) {
  return { ...s, open: [...s.open, pt] };
}

export function cutUndo(s) {
  if (s.open.length > 0) return { ...s, open: s.open.slice(0, -1) };
  if (s.lines.length > 0) {
    return { ...s, lines: s.lines.slice(0, -1), open: s.lines[s.lines.length - 1] };
  }
  return s;
}

export function cutFinishLine(s) {
  if (s.open.length < 2) return s;
  return { ...s, lines: [...s.lines, s.open], open: [] };
}

// The lines to submit: an unfinished open line with 2+ points counts.
export function cutEffectiveLines(s) {
  return s.open.length >= 2 ? [...s.lines, s.open] : s.lines;
}

// GeoJSON MultiLineString ([lng,lat] order) for the split RPCs.
export function cutLinesToGeoJSON(lines) {
  return {
    type: 'MultiLineString',
    coordinates: lines.map(l => l.map(([lat, lng]) => [lng, lat])),
  };
}
